import React from 'react';
import { FileText, Scale, AlertTriangle, CheckCircle2, XCircle, DollarSign, Clock, Shield, Mail, Phone } from 'lucide-react';
import Header from "../Header";
import Footer from "../Footer";

export default function TermsOfServicePage({ isDarkMode, setIsDarkMode }) {
  const sections = [
    {
      id: 1,
      icon: FileText,
      title: "1. Aceitação dos Termos",
      content: [
        {
          text: "Ao aceder e utilizar os serviços da AngoNet, você concorda em cumprir e estar vinculado a estes Termos de Serviço. Se não concordar com qualquer parte destes termos, não deverá utilizar nossos serviços.",
          list: [
            "Estes termos aplicam-se a todos os visitantes, utilizadores e clientes",
            "O uso continuado dos nossos serviços implica aceitação dos termos",
            "Reservamo-nos o direito de recusar serviço a qualquer pessoa por qualquer motivo",
            "Você deve ter pelo menos 18 anos para utilizar nossos serviços"
          ]
        }
      ]
    },
    {
      id: 2,
      icon: Scale,
      title: "2. Descrição dos Serviços",
      content: [
        {
          text: "A AngoNet oferece os seguintes serviços:",
          list: [
            "Instalação e manutenção de sistemas CCTV e segurança",
            "Cabeamento estruturado e infraestrutura de redes",
            "Desenvolvimento de websites e aplicações web",
            "Desenvolvimento de software personalizado",
            "Comercialização de software certificado pela AGT",
            "Consultoria em tecnologia da informação",
            "Suporte técnico e manutenção de sistemas"
          ]
        }
      ]
    },
    {
      id: 3,
      icon: DollarSign,
      title: "3. Preços e Pagamento",
      content: [
        {
          subtitle: "3.1 Orçamentos e Preços",
          text: "Todos os preços são apresentados em Kwanzas (AOA) e estão sujeitos a:",
          list: [
            "Validade conforme especificado no orçamento",
            "Alterações sem aviso prévio",
            "Impostos e taxas aplicáveis",
            "Condições específicas do projeto"
          ]
        },
        {
          subtitle: "3.2 Condições de Pagamento",
          list: [
            "Sinal de 50% no início do projeto",
            "30% na fase intermediária (conforme cronograma)",
            "20% na conclusão e entrega final",
            "Pagamentos podem ser efetuados por transferência bancária ou Multicaixa",
            "Atrasos de pagamento podem resultar em suspensão dos serviços"
          ]
        }
      ]
    },
    {
      id: 4,
      icon: Clock,
      title: "4. Prazos e Entregas",
      content: [
        {
          text: "Comprometemo-nos a cumprir os prazos acordados, sujeitos às seguintes condições:",
          list: [
            "Os prazos começam após confirmação do sinal inicial",
            "Atrasos causados pelo cliente não são da nossa responsabilidade",
            "Alterações no escopo podem afetar o cronograma",
            "Eventos de força maior podem justificar atrasos",
            "Notificaremos imediatamente sobre qualquer atraso previsto"
          ]
        }
      ]
    },
    {
      id: 5,
      icon: Shield,
      title: "5. Garantias",
      content: [
        {
          subtitle: "5.1 Garantia de Serviços",
          list: [
            "Cabeamento estruturado: 25 anos de garantia",
            "Equipamentos CCTV: Garantia do fabricante (1-3 anos)",
            "Software desenvolvido: 3 meses de garantia contra defeitos",
            "Instalações: 12 meses de garantia de mão de obra"
          ]
        },
        {
          subtitle: "5.2 Exclusões da Garantia",
          text: "A garantia não cobre:",
          list: [
            "Danos causados por uso indevido ou negligência",
            "Alterações não autorizadas pelo cliente",
            "Desastres naturais ou eventos de força maior",
            "Falta de manutenção adequada",
            "Danos causados por terceiros"
          ]
        }
      ]
    },
    {
      id: 6,
      icon: XCircle,
      title: "6. Cancelamento e Reembolso",
      content: [
        {
          subtitle: "6.1 Cancelamento pelo Cliente",
          list: [
            "Cancelamento antes do início: Reembolso de 90% do sinal",
            "Cancelamento com projeto iniciado: Sem reembolso do sinal",
            "Cancelamento após 50% do trabalho: Pagamento integral devido",
            "Cancelamento deve ser comunicado por escrito"
          ]
        },
        {
          subtitle: "6.2 Cancelamento pela AngoNet",
          text: "Reservamo-nos o direito de cancelar o contrato em caso de:",
          list: [
            "Falta de pagamento",
            "Fornecimento de informações falsas",
            "Comportamento abusivo ou ameaçador",
            "Impossibilidade técnica de execução",
            "Nestes casos, reembolsaremos valores pagos proporcionalmente ao trabalho não realizado"
          ]
        }
      ]
    },
    {
      id: 7,
      icon: AlertTriangle,
      title: "7. Limitação de Responsabilidade",
      content: [
        {
          text: "A AngoNet não será responsável por:",
          list: [
            "Danos indiretos, incidentais ou consequenciais",
            "Perda de lucros, dados ou oportunidades de negócio",
            "Interrupções de serviço causadas por terceiros",
            "Falhas em equipamentos fornecidos por terceiros",
            "Ações ou omissões de subcontratados aprovados pelo cliente"
          ]
        },
        {
          text: "Nossa responsabilidade máxima está limitada ao valor pago pelo serviço específico."
        }
      ]
    },
    {
      id: 8,
      icon: FileText,
      title: "8. Propriedade Intelectual",
      content: [
        {
          subtitle: "8.1 Software Desenvolvido",
          list: [
            "O código-fonte permanece propriedade da AngoNet até pagamento integral",
            "Após pagamento, o cliente recebe licença de uso perpétuo",
            "Modificações futuras podem estar sujeitas a custos adicionais",
            "Documentação técnica é fornecida ao cliente"
          ]
        },
        {
          subtitle: "8.2 Materiais do Cliente",
          list: [
            "Você mantém todos os direitos sobre materiais fornecidos",
            "Concede-nos licença para usar materiais no projeto",
            "Não usaremos seus materiais para outros fins sem autorização"
          ]
        }
      ]
    },
    {
      id: 9,
      icon: CheckCircle2,
      title: "9. Confidencialidade",
      content: [
        {
          text: "Comprometemo-nos a:",
          list: [
            "Manter confidenciais todas as informações do cliente",
            "Não divulgar detalhes técnicos ou comerciais",
            "Proteger dados contra acesso não autorizado",
            "Usar informações apenas para prestação do serviço contratado",
            "Destruir ou devolver informações confidenciais após conclusão"
          ]
        }
      ]
    },
    {
      id: 10,
      icon: Scale,
      title: "10. Lei Aplicável e Resolução de Disputas",
      content: [
        {
          text: "Estes termos são regidos pelas leis da República de Angola.",
          list: [
            "Qualquer disputa será resolvida preferencialmente por mediação",
            "Na impossibilidade de acordo, será submetida aos tribunais de Luanda",
            "O idioma oficial para resolução de disputas é o Português",
            "Custos legais serão suportados pela parte vencida"
          ]
        }
      ]
    },
    {
      id: 11,
      icon: FileText,
      title: "11. Disposições Gerais",
      content: [
        {
          list: [
            "Se alguma disposição for considerada inválida, as restantes permanecem em vigor",
            "A falta de exercício de qualquer direito não constitui renúncia",
            "Estes termos constituem o acordo completo entre as partes",
            "Alterações aos termos serão comunicadas com 30 dias de antecedência",
            "A versão mais recente dos termos está sempre disponível no website"
          ]
        }
      ]
    },
    {
      id: 12,
      icon: Mail,
      title: "12. Contacto",
      content: [
        {
          text: "Para questões sobre estes Termos de Serviço, contacte-nos:",
          contact: {
            email: "geral@angonet.ao",
            phone: "+244 945 574 552",
            address: "Luanda, Município de Viana, Angola"
          }
        }
      ]
    }
  ];

  return (
    <div className={`min-h-screen transition-colors duration-300 ${
      isDarkMode ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'
    }`}>
      {/* Animated Background Particles */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className={`absolute top-0 right-0 w-[800px] h-[800px] rounded-full blur-[120px] animate-pulse ${
          isDarkMode ? 'bg-blue-500/10' : 'bg-blue-400/20'
        }`}></div>
        <div className={`absolute bottom-0 left-0 w-[600px] h-[600px] rounded-full blur-[120px] animate-pulse ${
          isDarkMode ? 'bg-purple-500/10' : 'bg-purple-500/20'
        }`} style={{animationDelay: '1s'}}></div>
      </div>

      <Header isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />

      {/* Hero Section */}
      <section className={`relative pt-32 pb-20 px-6 ${
        isDarkMode ? 'bg-gray-800' : 'bg-gradient-to-br from-blue-50 to-purple-50'
      }`}>
        <div className="max-w-4xl mx-auto relative z-10 text-center">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-blue-500/10 border border-blue-500/30 rounded-full mb-6">
            <Scale size={20} className="text-blue-600" />
            <span className={`text-sm font-semibold ${
              isDarkMode ? 'text-cyan-400' : 'text-blue-600'
            }`}>
              Acordo Legal
            </span>
          </div>

          <h1 className={`text-4xl md:text-6xl font-bold mb-6 ${
            isDarkMode ? 'text-white' : 'text-gray-900'
          }`}>
            Termos de <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Serviço</span>
          </h1>
          
          <p className={`text-lg mb-4 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            Última atualização: 14 de Fevereiro de 2026
          </p>

          <p className={`text-xl ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            Por favor, leia atentamente estes Termos de Serviço antes de utilizar os serviços da AngoNet. 
            Ao usar nossos serviços, você concorda com estes termos.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 px-6 relative z-10">
        <div className="max-w-4xl mx-auto">
          {sections.map((section) => {
            const Icon = section.icon;
            return (
              <div
                key={section.id}
                className={`mb-12 p-8 rounded-2xl ${
                  isDarkMode ? 'bg-gray-800 border border-white/10' : 'bg-white border border-gray-200 shadow-lg'
                }`}
              >
                <div className="flex items-start space-x-4 mb-6">
                  <div className="flex-shrink-0 p-3 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg">
                    <Icon size={24} className="text-white" />
                  </div>
                  <h2 className={`text-2xl md:text-3xl font-bold ${
                    isDarkMode ? 'text-white' : 'text-gray-900'
                  }`}>
                    {section.title}
                  </h2>
                </div>

                {section.content.map((item, idx) => (
                  <div key={idx} className="mb-6 last:mb-0">
                    {item.subtitle && (
                      <h3 className={`text-xl font-bold mb-3 ${
                        isDarkMode ? 'text-cyan-400' : 'text-blue-600'
                      }`}>
                        {item.subtitle}
                      </h3>
                    )}
                    
                    {item.text && (
                      <p className={`mb-4 leading-relaxed ${
                        isDarkMode ? 'text-gray-400' : 'text-gray-600'
                      }`}>
                        {item.text}
                      </p>
                    )}

                    {item.list && (
                      <ul className="space-y-3">
                        {item.list.map((listItem, listIdx) => (
                          <li key={listIdx} className="flex items-start space-x-3">
                            <CheckCircle2 size={20} className="text-green-500 flex-shrink-0 mt-0.5" />
                            <span className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
                              {listItem}
                            </span>
                          </li>
                        ))}
                      </ul>
                    )}

                    {item.contact && (
                      <div className={`mt-4 p-4 rounded-lg ${
                        isDarkMode ? 'bg-gray-900' : 'bg-gray-50'
                      }`}>
                        <div className="space-y-3">
                          <div className="flex items-center space-x-3">
                            <Mail size={18} className={isDarkMode ? 'text-cyan-400' : 'text-blue-600'} />
                            <a
                              href={`mailto:${item.contact.email}`}
                              className={`hover:underline ${
                                isDarkMode ? 'text-cyan-400' : 'text-blue-600'
                              }`}
                            >
                              {item.contact.email}
                            </a>
                          </div>
                          <div className="flex items-center space-x-3">
                            <Phone size={18} className={isDarkMode ? 'text-cyan-400' : 'text-blue-600'} />
                            <a
                              href={`tel:${item.contact.phone.replace(/\s/g, '')}`}
                              className={`hover:underline ${
                                isDarkMode ? 'text-cyan-400' : 'text-blue-600'
                              }`}
                            >
                              {item.contact.phone}
                            </a>
                          </div>
                          <div className="flex items-start space-x-3">
                            <FileText size={18} className={`${isDarkMode ? 'text-cyan-400' : 'text-blue-600'} mt-0.5`} />
                            <span className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
                              {item.contact.address}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            );
          })}

          {/* Important Notice */}
          <div className={`p-6 rounded-xl border-2 ${
            isDarkMode
              ? 'bg-yellow-500/10 border-yellow-500/30'
              : 'bg-yellow-50 border-yellow-200'
          }`}>
            <div className="flex items-start space-x-3">
              <AlertTriangle className={`flex-shrink-0 mt-1 ${
                isDarkMode ? 'text-yellow-400' : 'text-yellow-600'
              }`} size={24} />
              <div>
                <h3 className={`text-lg font-bold mb-2 ${
                  isDarkMode ? 'text-white' : 'text-gray-900'
                }`}>
                  Importante
                </h3>
                <p className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
                  Estes Termos de Serviço constituem um acordo legal vinculativo. Recomendamos que consulte 
                  um advogado se tiver dúvidas sobre qualquer disposição. Ao usar nossos serviços, você confirma 
                  que leu, compreendeu e concordou com todos os termos aqui estabelecidos.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer isDarkMode={isDarkMode} />

      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}